import React, { useEffect, useState } from "react";

// import { loginUser, loginUserReq } from "../../../redux/ActionCreators";
import { useDispatch, useSelector } from "react-redux";
import adminAction from "../../../redux/admin/action";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import api from "../../../api";
import "./WaqarTopbar.css";

const WAQAR_PAGE_TITLES = {
  "/waqarzaka/stats": "Overview",
  "/waqarzaka/yubit-referrals": "Yubit Referrals",
  "/waqarzaka/trade-monitor": "Trade Monitor",
  "/waqarzaka/live-session-stats": "Live Session Stats",
  "/waqarzaka/stories": "Stories",
  "/waqarzaka/general": "General",
  "/waqarzaka/godzilla": "Telegram Signals",
};

export function NavbarAdmin({ adminType }) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { setAdmin } = adminAction;
  const adminStore = useSelector((state) => state.adminReducer);
  const notificationStore = useSelector((state) => state.notificationReducer);

  // const authedUser = useSelector(s => s.authedUser.authedUser);
  const logout = () => {
    const res = api.adminLogout();
    console.log(res);

    dispatch(setAdmin({}));
    console.log("remove token");

    localStorage.removeItem("token");
    navigate("/");
  };

  useEffect(() => {
    let token = localStorage.getItem("token");
    if (token) {
      axios.defaults.headers.common["Authorization"] = token;
    } else {
      logout();
    }
  }, []);

  const clickNoify = () => {
    if (notificationStore?.notification) {
      navigate("/admin/support");
    }
  };

  const isWaqarPortal =
    adminType == "mackAdmin777" &&
    adminStore?.admin?.admin?.email == "stats@waqarzaka.net";

  const waqarPageTitle = WAQAR_PAGE_TITLES[location.pathname] || "Overview";

  return (
    <>
      {/* Topbar */}
      <nav
        className={
          adminStore?.admin?.admin?.role == "sackAdmin755"
            ? "support navbar navbar-expand navbar-light bg-white topbar mb-4 static-top"
            : isWaqarPortal
              ? "navbar navbar-expand navbar-light topbar mb-4 static-top waqar-topbar"
              : "navbar navbar-expand navbar-light bg-white topbar mb-4 static-top"
        }
      >
        {/* Sidebar Toggle + Admin label (same row) */}
        <div className="d-flex align-items-center">
          <button
            className="btn btn-link d-md-none px-2"
            onClick={() =>
              document.body.classList.toggle("sidebar-mobile-open")
            }
            style={{ color: "#6c757d", fontSize: 18, minWidth: 36, width: 36 }}
          >
            <i className="fa-solid fa-bars" />
          </button>
          {adminStore?.admin?.admin?.role == "sackAdmin755" && (
            <h6 className="mb-0 ms-1" style={{ fontSize: 13 }}>
              {adminStore?.admin?.admin?.name}:{" "}
              {adminStore?.admin?.admin?.email}
            </h6>
          )}
          {isWaqarPortal && (
            <div className="waqar-topbar-heading">
              <span className="waqar-topbar-breadcrumb">
                Waqar Zaka / Admin
              </span>
              <span className="waqar-topbar-title">{waqarPageTitle}</span>
            </div>
          )}
        </div>
        <div className="walletBtn ms-auto px-3">
          {/* {adminStore?.admin?.admin?.email === "alex@waqarzaka.net" && ( */}
          {adminStore?.admin?.admin?.role == "sackAdmin755" && (
            <span className="notifyMain" onClick={clickNoify}>
              {notificationStore?.notification && (
                <div className="notify"></div>
              )}
              <i className="fa-solid fa-bell"></i>
            </span>
          )}
          <button
            className={isWaqarPortal ? "btn waqar-logout-btn" : "btn"}
            onClick={logout}
          >
            {isWaqarPortal ? "Logout" : "logout"}
          </button>
        </div>
      </nav>
      {/* End of Topbar */}
    </>
  );
}
